module.exports = __webpack_public_path__ + "static/media/logo_nome_sem_fundo.35801fa4.png";